/** A ready/probe duplicate must not close the port accepted by the same editor instance. */
export function createEditorHandshakeGuard<T>() {
  let active:{destination:T;instanceId:string}|null=null;
  return {
    accept(destination:T,instanceId:unknown){
      if(typeof instanceId!=='string'||instanceId.length===0||instanceId.length>128){active=null;return true;}
      if(active?.destination===destination&&active.instanceId===instanceId)return false;
      active={destination,instanceId};return true;
    },
    reset(){active=null;},
  };
}
/** Missing ids retain compatibility with a previously deployed parent. */
export const matchesEditorInstance=(expected:string,received:unknown)=>received===undefined||received===expected;
